import { createContext } from 'react';

export const HomeContext = createContext<HomeContextProps>({
	showInstallation: false,
	setShowInstallation: () => {},
});

interface HomeContextProps {
	showInstallation: boolean;
	setShowInstallation: (v: boolean) => void;
}

export interface Item {
	title: string;
	url: string;
	cover: string;
}
